module.exports = __webpack_public_path__ + "static/media/2018-normalized.f782db66.csv";